
import { useFormatGraphQLProductId } from "@/hooks/shopify-hooks/useShopifyUtils";
import { useProductByIdsApi } from '@/hooks/shopify-hooks/api/useProductApi'

/**
 * product list | wish list ...页面获取所有sku对应的shopify产品信息
 * 
 * @param {Object} params - 参数对象
 * @param {Array} params.products - spu产品列表 例: [{category: '1', sku: [{}, {}]}, {category: '2', sku: [{}, {}]}]
 * @returns {Promise} - 返回一个 Promise 对象，resolve 时传递 Shopify 产品数据映射对象 例：{'8341535818036': {}, '8341536833844':{}}
 */

// eslint-disable-next-line
export const useGetSkuShopifyInfo = async ({
  products = [],
} = {}) => {
  const ids = []
  products.forEach((spuItem) => {
    spuItem.sku.forEach((skuItem) => {
      const shopifyId = skuItem?.product?.shopifyId?.trim();
      if (shopifyId) {
        ids.push(shopifyId);
      }
    })
  })

  const productRes = await useProductByIdsApi(ids)
  return new Promise((resolve) => {
    const idToShopifyProductMap = {}; // 产品id映射shopify产品数据
    productRes?.forEach((item) => {
      const { id: shopifyId, variants } = item || {};
      const {
        id, // shopify product id
        availableForSale, // 是否在售
        quantityAvailable, // 库存
        compareAtPrice, // 原价
        price, // 售价
      } = variants?.nodes[0] || {};
      const key = ids.find((numId) => useFormatGraphQLProductId(numId) === shopifyId);
      if (key) {
        idToShopifyProductMap[key] = {
          id,
          availableForSale,
          quantityAvailable,
          compareAtPrice,
          price,
          productId: item?.id ? item?.id.split('/').pop() : null,
        };
      }
    });
    resolve(idToShopifyProductMap);
  })
}